import { ImageUpload } from "app/components/organisms/ImageUpload";
import { StatusFlagModel } from "app/services/api/types/statusFlags/models/StatusFlagModel";
import { Controller } from "react-hook-form";
import { View } from "ui/atoms/view";
import { useHandleCreateEditFlag } from "../hooks/useHandleCreateEditFlag";
import { CreateFlagRequest } from "app/services/api/types/statusFlags/requests/CreateFlagRequest";
import { requiredValidation } from "ui/utils/Validators";
import { FormControlledInput } from "ui/molecules/form/FormControlledInput";
import {
  Checkbox,
  CheckboxIcon,
  CheckboxIndicator,
  CheckboxLabel,
} from "ui/gluestack/checkbox";
import { CheckIcon } from "ui/gluestack/icon";
import { Button, ButtonText } from "ui/gluestack/button";
import { residentProfileMimeTypes } from "app/constants/allowedExtensionsConstants";

interface Props {
  onClose: () => void;
  onSuccess?: () => void;
  isEditing?: boolean;
  flag?: StatusFlagModel;
}

export default function AddStatusFlagForm({
  onClose,
  onSuccess,
  isEditing,
  flag,
}: Props) {
  const { control, handleFlagSubmission, isLoadingAction } =
    useHandleCreateEditFlag(onSuccess, flag);

  return (
    <View>
      <View className="border-gray-200 border mt-5 mb-12" />
      <Controller
        control={control}
        name="icon"
        render={({ field: { value, onChange }, fieldState: { error } }) => {
          return (
            <ImageUpload
              value={value}
              onChange={onChange}
              onRemove={() => {
                onChange(undefined);
              }}
              allowedExtensions={residentProfileMimeTypes}
              errorMessage={error}
            />
          );
        }}
      />

      <View className="mt-12 mb-5 max-w-80">
        <FormControlledInput<CreateFlagRequest>
          id="name"
          name="name"
          type="text"
          control={control}
          label={"Status Flag Name"}
          placeholder={"Enter name of status flag"}
          isRequired
          isDisabled={isLoadingAction}
          rules={{
            required: requiredValidation("Status Flag Name"),
          }}
          onSubmitEditing={handleFlagSubmission}
        />
      </View>
      <Controller
        control={control}
        name="visible"
        render={({ field: { value, onChange } }) => (
          <Checkbox
            isChecked={!!value}
            onChange={(checked: boolean) => onChange(checked)}
            aria-label="Preparation needed"
            size="sm"
            className="gap-4 mb-4"
            value={value ? "checked" : "unchecked"}
          >
            <CheckboxIndicator>
              <CheckboxIcon as={CheckIcon} />
            </CheckboxIndicator>
            {/* eslint-disable-next-line react-native/no-raw-text */}
            <CheckboxLabel>Visible to all carers</CheckboxLabel>
          </Checkbox>
        )}
      />
      <View className="flex flex-row justify-end gap-x-4 mt-10 pb-4">
        <Button action="primary" size="sm" variant="outline" onPress={onClose}>
          <ButtonText className="text-primary-500 font-semibold">
            Cancel
          </ButtonText>
        </Button>
        <Button action="primary" size="sm" onPress={handleFlagSubmission}>
          <ButtonText className="text-white">
            {isEditing ? "Update" : "Create"}
          </ButtonText>
        </Button>
      </View>
    </View>
  );
}
